import Account from "@/features/account/application/domain/entities/account";

export class AppUser {
  appUserId: string;
  accountId: string;
  email: string;
  firstName: string;
  lastName: string;
  contactPhone: string;
  jobTitle: string;
  vtAppRole: string;
  account?:Account | null

  constructor(
    appUserId: string,
    accountId: string,
    email: string,
    firstName: string,
    lastName: string,
    contactPhone: string,
    jobTitle: string,
    vtAppRole: string,
    account?:Account | null,
  ) {
    this.appUserId = appUserId;
    this.accountId = accountId;
    this.email = email;
    this.firstName = firstName;
    this.lastName = lastName;
    this.contactPhone = contactPhone;
    this.jobTitle = jobTitle;
    this.vtAppRole = vtAppRole;
    this.account = account;
  }
}
